import React, { useEffect } from 'react';
import { Input } from 'antd';
import { useSelector } from 'react-redux';
import { selectMilesOut } from 'Redux/Location/slice';
import { selectCurrentDriver } from 'Redux/Driver/slice';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { selectCurrentUser } from 'Redux/User/slice';
import {
  fillOutHTMLWithVars,
  dimsToString,
  formatDate,
  secondsToMinutes,
} from 'Shared/Utils';
import ContentWithBreaks from 'Components/UI/ContentWithBreaks';
import styles from './Letter.module.scss';

type LetterProps = {
  brokerPrice: number;
  letter: string;
  letterChangeHandler: (newLetter: string) => void;
  comment: string;
  commentChangeHandler: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const Letter: React.FC<LetterProps> = ({
  brokerPrice,
  letter,
  letterChangeHandler: changeLetter,
  comment,
  commentChangeHandler: handleCommentChange,
}) => {
  const driver = useSelector(selectCurrentDriver);
  const currentOrder = useSelector(selectCurrentOrder);
  const currentUser = useSelector(selectCurrentUser);
  const milesOut = useSelector(selectMilesOut);

  // filling out the mail letter body
  useEffect(() => {
    changeLetter(
      fillOutHTMLWithVars(String(driver?.template.content), {
        vehicleSize: dimsToString({
          length: driver?.vehicle.length,
          width: driver?.vehicle.width,
          height: driver?.vehicle.height,
        }),
        driverMilesOut: milesOut?.distanceInMi || '',
        eta: secondsToMinutes(milesOut?.durationInSec),
        dockLevel: driver?.vehicle.dock_high,
        locationFrom: currentOrder?.pick_up_at || '',
        pickupDate: formatDate({
          date: currentOrder?.pick_up_date,
          isEST: true,
        }),
        locationTo: currentOrder?.deliver_to || '',
        deliveryDate: formatDate({
          date: currentOrder?.deliver_date,
          isEST: true,
        }),
        dispatcherName: `${currentUser?.first_name} ${currentUser?.last_name}`,
        dispatcherPhone: currentUser?.phone_number,
        dispatcherEmail: currentUser?.email,
      }),
    );
  }, [driver, milesOut, currentOrder, currentUser]);

  return (
    <div className={styles.letter}>
      <div className={styles.letter__scrollbarWrapper}>
        <Input.TextArea
          className={styles.letter__comment}
          onChange={handleCommentChange}
          autoSize={{ minRows: 2, maxRows: 4 }}
          placeholder="Your comments..."
          name="comment"
        />
      </div>
      {driver && (
        <ContentWithBreaks
          content={fillOutHTMLWithVars(letter, {
            comment,
            brokerPrice,
          })}
        />
      )}
    </div>
  );
};
